import axios from 'axios';
import store from '@/store'
import i18n from "@/helpers/i18n";

let refreshTokenRequest: any = store.getters['auth/isRefresh'];
let isRefresh = false


let token = localStorage['access-token'];


export default function setup() {
    axios.interceptors.request.use(async function (config) {
        const locale = localStorage['lang']
        if (locale) {
            config.headers.common['LF-Localization'] = locale;
        } else {
            config.headers.common['LF-Localization'] = 'ru';
        }

        if (isRefresh) {
            if (config.url && config.url.indexOf('/token/refresh') !== -1) {
                return config;
            }
            token = await refreshTokenRequest;

        } else {
            token = localStorage['access-token'];
        }

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        } else {
            config.headers.Authorization = null;
        }

        return config;
    }, function (err) {
        return Promise.reject(err);
    });
}
axios.interceptors.response.use( function (response) {
    return response;
}, async function (error) {
    const originalRequest = error.config;
    // all the other error responses
    switch (error.response.status) {
        case 403:
            if(error.response.data.error === 'invalid_refresh_token'){
                store.commit('auth/clear')
            } else{
                // alert(i18n.t('error.some_error.403_title'))
                store.commit('dialog/SetFullError',{
                    titleError:i18n.t('error.some_error.403_title'),
                    isBtnHome:true
                })
                store.commit('dialog/SetFullPlanShow',false)
            }
            break;
        case 401: // authentication error, logout the user
            isRefresh = true
            const data = await store.dispatch('auth/refresh');
            if(data){
                originalRequest.headers.Authorization = 'Bearer ' + localStorage.getItem('access-token');
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access-token');
                isRefresh = false
                return  axios(originalRequest)
            }else {
                store.commit('auth/clear')
            }

            break;
        case 400: // authentication error, logout the user
            console.log(error.response.status)
            break;
        default:
            store.commit('alerts/setAlert', {
                show: true,
                messages: ['Ошибка сервера: ' + error.response.status]
            })
    }
    return Promise.reject(error);
});
